import { Component, OnInit } from '@angular/core';
import { Status } from './core/parameters/documents';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  ngOnInit(): void {
   console.log(Status);
  }
  title = 'afrac';

}
